export default function FamilyHolidayIntro() {
  return (
    <section className="py-16 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-[#1A1F2E] mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Why These Are the Best Muslim Family Holiday Destinations
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Discover handpicked destinations perfect for Muslim families traveling from the UK. Each location offers authentic halal dining, family-friendly attractions, prayer facilities, and cultural comfort—ensuring memorable holidays where your values and needs are respected.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 max-w-5xl mx-auto">
          <div className="flex flex-col items-center text-center p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow">
            <div className="w-14 h-14 flex items-center justify-center bg-[#14B8A6]/10 rounded-full mb-4">
              <i className="ri-restaurant-2-line text-2xl text-[#14B8A6]"></i>
            </div>
            <h3 className="text-sm font-semibold text-[#1A1F2E] mb-2">Halal Food Guaranteed</h3>
            <p className="text-xs text-gray-600">100% halal dining options</p>
          </div>

          <div className="flex flex-col items-center text-center p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow">
            <div className="w-14 h-14 flex items-center justify-center bg-[#14B8A6]/10 rounded-full mb-4">
              <i className="ri-parent-line text-2xl text-[#14B8A6]"></i>
            </div>
            <h3 className="text-sm font-semibold text-[#1A1F2E] mb-2">Family-Friendly</h3>
            <p className="text-xs text-gray-600">Safe activities for children</p>
          </div>

          <div className="flex flex-col items-center text-center p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow">
            <div className="w-14 h-14 flex items-center justify-center bg-[#14B8A6]/10 rounded-full mb-4">
              <i className="ri-community-line text-2xl text-[#14B8A6]"></i>
            </div>
            <h3 className="text-sm font-semibold text-[#1A1F2E] mb-2">Muslim-Friendly</h3>
            <p className="text-xs text-gray-600">Welcoming Muslim communities</p>
          </div>

          <div className="flex flex-col items-center text-center p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow">
            <div className="w-14 h-14 flex items-center justify-center bg-[#14B8A6]/10 rounded-full mb-4">
              <i className="ri-shield-check-line text-2xl text-[#14B8A6]"></i>
            </div>
            <h3 className="text-sm font-semibold text-[#1A1F2E] mb-2">Safe for Children</h3>
            <p className="text-xs text-gray-600">Secure family environments</p>
          </div>

          <div className="flex flex-col items-center text-center p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow">
            <div className="w-14 h-14 flex items-center justify-center bg-[#14B8A6]/10 rounded-full mb-4">
              <i className="ri-ancient-pavilion-line text-2xl text-[#14B8A6]"></i>
            </div>
            <h3 className="text-sm font-semibold text-[#1A1F2E] mb-2">Prayer Facilities</h3>
            <p className="text-xs text-gray-600">Mosques &amp; prayer rooms</p>
          </div>
        </div>

        <div className="mt-12 bg-white rounded-2xl shadow-lg p-8 max-w-4xl mx-auto border border-gray-100">
          <div className="flex items-start space-x-4">
            <div className="w-12 h-12 flex items-center justify-center bg-[#14B8A6]/10 rounded-full flex-shrink-0">
              <i className="ri-information-line text-2xl text-[#14B8A6]"></i>
            </div>
            <div>
              <h3 className="text-xl font-bold text-[#1A1F2E] mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
                Curated by Muslim Travel Experts
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Our team has personally visited and vetted each destination to ensure they meet the highest standards for Muslim family travel. From halal breakfast buffets to nearby mosques, from modest beach resorts to child-friendly cultural attractions—we've done the research so you can travel with confidence and peace of mind.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}